var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 339,
    viewBox: "0 0 418 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_1409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.641 185.436C381.482 185.336 381.322 185.246 381.152 185.146C369.663 178.452 356.117 175.874 343.071 172.647C330.943 169.65 317.327 165.623 308.014 156.781C296.695 146.03 298.272 131.214 302.624 117.755C307.196 103.628 311.508 89.3905 309.482 74.3938C307.176 57.2989 299.49 40.7935 287.272 27.9649C268.316 8.0625 238.939 -2.48816 210.8 0.499197C173.038 4.50565 142.024 30.5626 118.476 58.7976C103.024 77.3212 93.9106 98.3526 76.2824 115.947C58.8639 133.332 39.2892 148.998 24.6357 168.7C5.12088 194.917 -4.38197 228.358 1.94661 259.87C8.28517 291.382 31.4234 320.136 63.1162 331.516C83.2998 338.76 105.44 338.91 127.021 338.97C171.86 339.09 216.749 339.199 261.438 335.802C290.845 333.564 320.651 329.658 347.443 317.968C374.235 306.279 397.962 285.747 406.746 259.09C415.47 232.604 406.397 200.222 381.631 185.446L381.641 185.436Z",
    fill: "#BFD2FF",
    fillOpacity: 0.13
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_883_1409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 220,
    width: 336,
    height: 61,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 249.5,
    r: 20.5,
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 239,
    width: 21,
    height: 7,
    rx: 3,
    fill: "#84BBFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 239,
    width: 54,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 253,
    width: 112,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 234,
    width: 81,
    height: 31,
    fill: "#DDEDFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_883_1409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 158,
    width: 335,
    height: 61,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 187.5,
    r: 20.5,
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 177,
    width: 21,
    height: 7,
    rx: 3,
    fill: "#84BBFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 177,
    width: 57,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 191,
    width: 120,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 172,
    width: 81,
    height: 31,
    fill: "#DDEDFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_883_1409)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_883_1409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 96,
    width: 338,
    height: 61,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 125.5,
    r: 20.5,
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 115,
    width: 21,
    height: 7,
    rx: 3,
    fill: "#84BBFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 115,
    width: 57,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 129,
    width: 115,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 110,
    width: 81,
    height: 31,
    fill: "#DDEDFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_883_1409",
    x: 5,
    y: 220,
    width: 376,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_883_1409",
    result: "effect2_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_883_1409",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_883_1409",
    x: 43,
    y: 158,
    width: 375,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_883_1409",
    result: "effect2_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_883_1409",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_883_1409",
    x: 27,
    y: 96,
    width: 378,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_883_1409",
    result: "effect2_dropShadow_883_1409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_883_1409",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_1409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 410,
    height: 339,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_883_1409"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 96,
    width: 338,
    height: 61,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/Task.7a6fcb3a62fae5a1750217ad73140336.svg";
export { ForwardRef as ReactComponent };